import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import AlertCircleIcon from "@/shared/icons/AlertCircleIcon";
import styles from "./RadioInput.module.scss";
import { FieldSettings, TextObject } from "@/shared/types";

interface RadioInputProps {
  registerProps?: UseFormRegisterReturn;
  isError?: boolean;
  fieldSettings: FieldSettings;
  text: TextObject;
}

const RadioInput: React.FC<RadioInputProps> = ({
  registerProps,
  isError,
  fieldSettings,
  text,
}) => {
  return (
    <div className={styles.radioWrapper}>
      {fieldSettings?.options?.map((option) => (
        <div key={option?.id} className={`${styles.radioInput}`}>
          <input
            id={option?.id}
            value={text[option?.label?.textId!]}
            type="radio"
            {...registerProps}
          />
          <label
            htmlFor={option?.id}
            id="general-text"
            style={{ cursor: "pointer" }}
            className="general-input-label"
          >
            {text[option?.label?.textId!]}
          </label>
        </div>
      ))}
      {isError && <AlertCircleIcon />}
    </div>
  );
};

export default RadioInput;
